module.exports = __webpack_public_path__ + "img/Liza.e721d978.svg";